import {
  MenuItemRadio,
  makeStyles,
  mergeClasses,
  tokens,
} from "@fluentui/react-components";
import React from "react";

import { SUPPORTED_LANGS } from "@/i18n/supportedLangs";

import {
  LANGUAGE_SELECT_ENDONYMS,
  LANGUAGE_SELECT_RADIO_NAME,
} from "../constants";

const useStyles = makeStyles({
  option: {
    maxWidth: "none",
    minHeight: "33px",
    alignItems: "center",
    '&[aria-checked="false"]': {
      color: tokens.colorNeutralForeground3,
    },
  },
  checkmark: {
    color: "var(--figma-color-success-green)",
  },
});

/**
 * 言語選択の行。MenuList の中で使い、選択状態は
 * useLanguageSelectMenuCheckedProps を Menu に渡すことで接続する。
 */
export const LanguageSelectMenuItems: React.FC<{ className?: string }> = ({
  className,
}) => {
  const styles = useStyles();

  return (
    <>
      {SUPPORTED_LANGS.map((lang) => (
        <MenuItemRadio
          key={lang}
          className={mergeClasses(styles.option, className)}
          checkmark={{ className: styles.checkmark }}
          name={LANGUAGE_SELECT_RADIO_NAME}
          value={lang}
        >
          {LANGUAGE_SELECT_ENDONYMS[lang]}
        </MenuItemRadio>
      ))}
    </>
  );
};
